import { takeEvery, all, put, call } from "redux-saga/effects"
import { browserHistory } from "react-router"
import { DckActionTypes, DckActionCreators } from "dck-redux"

import jwtDecode from "jwt-decode"
import authServerConstans from "./authServerConstans"
import store from "store"
import * as authRequest from "./authRequest"
import * as ActionTypes from "../actions/types"
import apiServerApi from "./apiServerApi"
import * as ItemTypes from "../../redux/items/types"
import authServerApi from "./authServerApi"
import { parseFetchError } from "../../lib/utils"

function* signInSaga({ email, password }) {

  store.set('organization', {})
  store.remove("organization")
  yield put(DckActionCreators.asyncProcessStart(DckActionTypes.SIGN_IN))

  let sessionData,
    authenticated,
    errorMsg = ''

  try {

    const result = yield call(
      authRequest.makeAuthRequest,
      authRequest.LOGIN,
      { email, password }
    ),

    accessToken = result.access_token,
    refreshToken = result.refresh_token,

    decodedToken = jwtDecode(accessToken),
    isSuper = decodedToken.authorities.includes(authServerConstans.superRoleName),
    isAdmin = decodedToken.authorities.includes(authServerConstans.adminRoleName),
    isApprover = decodedToken.authorities.includes(authServerConstans.approverRoleName),
    isUnderwiter = decodedToken.authorities.includes(authServerConstans.underwriterRoleName),
    isAccountant = decodedToken.authorities.includes(authServerConstans.accountantRoleName),
    isPaymentManager = decodedToken.authorities.includes(authServerConstans.paymentManagerRoleName),

    isAuthorized = isSuper || isAdmin || isApprover || isUnderwiter || isAccountant || isPaymentManager

    if(isAuthorized && refreshToken != null) {

      const userReq = yield call(authServerApi.getByUsername, accessToken, decodedToken.user_name),
      userInfo = userReq.data
      if(!userInfo) {
        throw new Error('Failed to get user data!')
      }
  
      const organizationId = userInfo.organizationId
      if(!isSuper && !organizationId) {
        throw new Error("Organization not found!")
      }

      // Get user organization details
      if(organizationId) {
        const organizationReq = yield call(apiServerApi.getOrganizationById, accessToken, organizationId)
        store.set('organization', organizationReq.body)
      }

      store.set("sessionData", { access_token: accessToken })

      // Must change the password
      if(!userInfo.alreadyLogged) {
        yield call(browserHistory.push, `/update-password/${userInfo.id}`)
        return
      }

      sessionData = {
        access_token: accessToken,
        refresh_token: refreshToken,
        authorities: decodedToken.authorities
      }
      authenticated = true

      // Verify 2FA code
      store.set("userInfo", userInfo);
      store.set("tempoSessionData", sessionData)
      yield put(DckActionCreators.asyncProcessStart(ItemTypes.VerifCode))
    }
    else {
      errorMsg = "This user doesn't have enough permissions to access to AdminUI"
      authenticated = false
    }
  }
  catch(error) {
    errorMsg = parseFetchError(error).text
    authenticated = false;
  }

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_STOP,
    processCode: DckActionTypes.SIGN_IN,
    result: {
      success: authenticated,
      text: errorMsg,
    }
  })
}

function *validateVerifCodeSaga(action) {

  let errorMsg = '',
  success = false
  const tempoSessionData = store.get("tempoSessionData")

  yield put(DckActionCreators.asyncProcessStart(ItemTypes.Send2FA))
  try {
    const userData = yield call(authServerApi.validate2FACode, tempoSessionData.access_token, action.code)
    store.set("userInfo", userData.data)
    success = true
  }
  catch(error) {
    errorMsg = parseFetchError(error).text
  }

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_STOP,
    processCode: ItemTypes.Send2FA,
    result: {
      success,
      text: errorMsg,
    }
  })

  if(success) { // 2-Step verification is OK

    yield put(DckActionCreators.asyncProcessReset(ItemTypes.VerifCode))
    yield put({
      type: DckActionTypes.INITIALIZE_USER_SESSION,
      sessionData: tempoSessionData,
      authenticated: true
    })

    store.set("sessionData", tempoSessionData)
    store.remove("tempoSessionData")

    const date = new Date();
    store.set('lastLogin', date.toLocaleString())
    yield call(browserHistory.push, "/")
  }
}

function *resetVerifCode() {
  yield put(DckActionCreators.asyncProcessReset(ItemTypes.VerifCode))
  store.remove('userInfo')
  store.remove("tempoSessionData")
}

function* checkAuthenticatedSaga() {

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_START,
    processCode: DckActionTypes.CHECK_AUTHENTICATED
  })

  let result
  try {
    result = yield call(authRequest.makeAuthRequest, authRequest.IS_USER_AUTHENTICATED)
    if (result !== true) {
      yield call(browserHistory.push, "/sign-in")
    }
  }
  catch (e) {
    console.error(e)
  }

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_STOP,
    processCode: DckActionTypes.CHECK_AUTHENTICATED,
    result: { success: result }
  })
}

function* checkNotAuthenticatedSaga() {

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_START,
    processCode: DckActionTypes.CHECK_AUTHENTICATED
  })

  let result
  try {
    result = yield call(authRequest.makeAuthRequest, authRequest.IS_USER_AUTHENTICATED)
    if(result === true) {
      yield call(browserHistory.push, "/")
    }
  }
  catch (e) {
    console.error(e)
  }

  yield put({
    type: DckActionTypes.ASYNC_PROCESS_STOP,
    processCode: DckActionTypes.CHECK_AUTHENTICATED,
    result: { success: result }
  })
}

function* signOut() {

  yield put(DckActionCreators.initializeUserSession({}, false))
  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.Loan,
    data: []
  })

  store.set("sessionData", {})
  store.remove("organization")
  yield call(browserHistory.push, "/sign-in")
}

function* accountSaga() {

  yield all([

    takeEvery(DckActionTypes.SIGN_IN, signInSaga),

    takeEvery(DckActionTypes.CHECK_AUTHENTICATED, checkAuthenticatedSaga),

    takeEvery(ActionTypes.CHECK_NOT_AUTHENTICATED, checkNotAuthenticatedSaga),

    takeEvery(DckActionTypes.SIGN_OUT, signOut),

    takeEvery(ActionTypes.VALIDATE_VERIF_CODE, validateVerifCodeSaga),

    takeEvery(ActionTypes.VERIF_CODE_RESET, resetVerifCode),
  ])
}

export default accountSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/account.js